import { render, staticRenderFns } from "./BaseSideBarItem.vue?vue&type=template&id=b477d844&"
import script from "./BaseSideBarItem.vue?vue&type=script&lang=js&"
export * from "./BaseSideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b477d844')) {
      api.createRecord('b477d844', component.options)
    } else {
      api.reload('b477d844', component.options)
    }
    module.hot.accept("./BaseSideBarItem.vue?vue&type=template&id=b477d844&", function () {
      api.rerender('b477d844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseSideBarItem.vue"
export default component.exports